/**
 * 活动列表项组件
 */

import React from 'react';
import { Button } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import type { MarketingActivity } from '../../../ProfitScenario/types/marketingActivities';
import { getActivityTypeLabel } from './utils';

interface ActivityItemProps {
    activity: MarketingActivity;
    onDelete: (id: string) => void;
}

export const ActivityItem: React.FC<ActivityItemProps> = ({ activity, onDelete }) => {
    return (
        <div
            style={{
                marginBottom: 6,
                padding: '6px 8px',
                background: '#f5f5f5',
                borderRadius: 4,
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
            }}
        >
            <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 500 }}>
                    {getActivityTypeLabel(activity.type)}
                    {activity.marketplace && ` (${activity.marketplace})`}
                </div>
                <div style={{ fontSize: 11, color: '#666' }}>
                    {activity.units} 个 · ${activity.totalCost.toFixed(0)}
                </div>
            </div>
            <Button
                type="text"
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={() => onDelete(activity.id)}
            />
        </div>
    );
};
